import { FC } from "react";
import { Select, SelectProps } from "antd";
import { clsx } from "clsx";
import { SvgIcon } from "./components/SvgIcon";
import classes from "./GenericSelect.module.less";

export const GenericSelect: FC<SelectProps> = ({
    suffixIcon,
    className,
    popupClassName,
    ...props
}) => {
    return (
        <Select
            suffixIcon={<SvgIcon name="down" size={12} />}
            className={clsx(classes.select, className)}
            popupClassName={clsx(classes.popup, popupClassName)}
            {...props}
        />
    );
};
